<template>
  <div class="mian_c">
      <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div
            style="text-align: center; font-size: 0.35rem; margin-left: -0.2rem"
          >
            提前还款计算器
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="c_m">
      <div class="c_data">
        <div class="c_still">一次性还清-当月需还</div>
        <div class="c_money">4536.7</div>
        <div class="c_flex">
          <div>
            <p>已还利息</p>
            <p>100万</p>
          </div>
          <div>
            <p>已还本金</p>
            <p>30年</p>
          </div>
        </div>
      </div>
      <div class="m_b">
        <div class="whole" style="display: none">
          <div>
            <p>可节省利息</p>
            <p>38.15万元</p>
          </div>
          <div>
            <p>可节省利息</p>
            <p>38.15万元</p>
          </div>
        </div>
        <div class="part">
          <div>
            <h2>月供减少 年限不变</h2>
            <div>
              <ul>
                <li>次月还款</li>
                <li>307.55元</li>
                <li>可节省利息</li>
                <li>3.21元</li>
                <li>最后还款日期</li>
                <li>2048年4月</li>
              </ul>
            </div>
          </div>
          <div>
            <h2>月供不变 年限缩短</h2>
            <div>
              <ul>
                <li>次月还款</li>
                <li>307.55元</li>
                <li>可节省利息</li>
                <li>3.21元</li>
                <li>最后还款日期</li>
                <li>2048年4月</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="b_word">以上结果仅供参考，请以当地实际情况为准</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      loanPicker: false,
      ratePicker: false,
      yearsPicker: false,
      tab: 0,
      radio: "1",
      yearsList: [
        "1年",
        "2年",
        "3年",
        "4年",
        "5年",
        "6年",
        "7年",
        "8年",
        "9年",
        "10年",
        "11年",
        "12年",
        "13年",
        "14年",
        "15年",
        "16年",
        "17年",
        "18年",
        "19年",
        "20年",
        "21年",
        "22年",
        "23年",
        "24年",
        "25年",
        "26年",
        "27年",
        "28年",
        "29年",
        "30年",
      ],
      rateList: ["按旧版基准利率", "按LRP"],
      arrList: [
        {
          name1: "1",
          name2: "1",
          name3: "1",
          name4: "1",
          name5: "1",
        },
      ],
    };
  },
  methods: {
    yearsConfirm(value) {},
    changeTab(type) {
      this.tab = type;
      // if (type == 0) {
      //   this.definition = "人才";
      // }
      // if (type == 1) {
      //   this.definition = "刚需";
      // }
      // if (type == 2) {
      //   this.definition = "普通";
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.top_header {
  height: 0.5rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.c_m {
  margin-top: 0.1rem;
  padding: 0 0.5rem;
  .c_data {
    padding: 0.3rem;
    background: #007fff;
    color: #fff;
    font-size: 0.2rem;
    .c_still {
      padding: 0.1rem;
      text-align: center;
    }
    .c_money {
      padding: 0.1rem;
      text-align: center;
      font-size: 0.5rem;
      font-weight: 900;
    }
    .c_flex {
      padding: 0.1rem;
      display: flex;
      div {
        text-align: center;
        flex: 1;
      }
    }
  }
}
.mian_c {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0 0.2rem;
  .m_b {
    margin-top: 1rem;
    border: 2px solid #cfcfcf;
    padding: 0.5rem 0;
    .whole {
      & > div {
        padding: 0.3rem 0;
        display: flex;
        p {
          font-size: 0.25rem;
          flex: 1;
          text-align: center;
          color: #323232;
          &:first-child {
            color: #cfcfcf;
          }
        }
      }
    }
    .part {
      display: flex;
      h2 {
        text-align: center;
        font-size: 0.3rem;
        font-weight: 900;
      }
      & > div {
        flex: 1;
      }
      ul {
        padding-top:0.5rem;
        font-size: 0.25rem;
        padding-left: 0.4rem;
        li {
          padding: 0.1rem 0;
          &:nth-child(odd) {
            color: #ccc;
          }
        }
      }
    }
  }
  .b_word{
    position: absolute;
    width:calc(100% - 0.4rem);
    text-align: center;
    bottom: 0.5rem;
    right:0.2rem;
    left:0.2rem;
    color: #ccc;
    font-size: 0.3rem;
  }
}
</style>